import { connect, type ConnectedProps } from 'react-redux'
import type { AnyAction } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'
import type { StoreStateType } from 'index'
import { Helmet } from 'react-helmet'
import { sendNativeMessage } from 'util/native'
import { createLegalAgreements } from 'util/server/mainApi'
import { signingApi } from 'util/server/signingApi'
import { termsSelector } from 'selectors'
import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import { Agreements, Container, RoadieUIThemeRealm } from 'roadie-ui'
import { getProfile } from 'actions/profile'
import { toLegalAgreementSubmission, type AgreementCompletedArgs, type LegalAgreement } from 'data/agreements'
import { useLocalization } from 'localization'

const connector = connect(termsSelector)
type TermsProps = Omit<ConnectedProps<typeof connector>, 'dispatch'> & {
  dispatch: ThunkDispatch<StoreStateType, void, AnyAction>
}

const Terms = ({ termsDocuments, isWebview, mediaSize, dispatch }: TermsProps) => {
  const { t } = useLocalization()
  const agreements: LegalAgreement[] = termsDocuments?.documents ?? []
  const isWebOrMobile = isWebview || mediaSize === 'mobile'

  const fetchAgreementHtml = (agreement: Pick<LegalAgreement, 'version_id'>) =>
    signingApi.fetchDocumentHtml(agreement.version_id)

  const handleAgreementCompleted = async (args: AgreementCompletedArgs) => {
    await createLegalAgreements([toLegalAgreementSubmission(args)])
  }

  const handleAllAgreementsCompleted = async () => {
    sendNativeMessage({ type: 'TERMS_ACCEPTED' })
    await dispatch(getProfile())
  }

  return (
    <Page>
      <Helmet>
        <title>{t('dweb_terms_terms_conditions')}</title>
      </Helmet>
      <Thin>
        <RoadieUIThemeRealm mode="light">
          <Container.Panel $paddingMedia={{ mobile: '0' }}>
            <Container.Base
              $minHeight="60rem"
              $height={isWebview ? '100vh' : '75vh'}
              $padding={isWebOrMobile ? '2.4rem 2.4rem 2.4rem 2.4rem' : undefined}
            >
              <Agreements
                agreements={agreements}
                fetchAgreementHtml={fetchAgreementHtml}
                onAgreementCompleted={handleAgreementCompleted}
                onAllAgreementsCompleted={handleAllAgreementsCompleted}
              />
            </Container.Base>
          </Container.Panel>
        </RoadieUIThemeRealm>
      </Thin>
    </Page>
  )
}

export default connector(Terms)
